import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from 'tss-react/mui';
import { CardContent, CardMedia, Card } from '@mui/material';
import { useTranslation } from 'react-i18next';
import utils from 'src/utils/utils';

const useStyles = makeStyles()(theme => ({
  card: {
    width: '200px',
    display: 'inline-block',
    margin: '10px',
  },
  cardContent: {
    height: '3em',
    wordBreak: 'break-word',
    wordWrap: 'normal',
    color: theme.palette.primary.main,
    display: 'table-cell',
    verticalAlign: 'middle',
  },
  media: {
    height: 200,
    cursor: 'pointer',
    backgroundSize: 'contain',
  },
}));

function MessageModelItem({ messageModel, onMessageModelSelect, name, lang, hideLang }) {
  const { t } = useTranslation();
  const { classes } = useStyles();
  return (
    <Card className={classes.card}>
      <CardContent className={classes.cardContent}>
        {name ||
          t(
            `smartmessaging.campaignEditor.messageModel.${
              messageModel.key.slice(-3).match(/_[A-Z]{2}/) ? 'resaModel' : messageModel.key
            }`
          )}
        {!hideLang && ` - ${t(`smartmessaging.language.${lang}`)}`}
      </CardContent>
      <CardMedia
        onClick={e => {
          e.preventDefault();
          onMessageModelSelect(messageModel);
        }}
        className={classes.media}
        image={utils.link(messageModel.pictoStoredFileId)}
        title={messageModel.key}
      />
    </Card>
  );
}

MessageModelItem.propTypes = {
  messageModel: PropTypes.object.isRequired,
  onMessageModelSelect: PropTypes.func.isRequired,
  name: PropTypes.string,
  hideLang: PropTypes.bool.isRequired,
  lang: PropTypes.string,
};

MessageModelItem.defaultProps = { name: '', lang: null };

export default MessageModelItem;
